import { Modal } from 'antd';
import { setCurrPlanCode } from 'features/siteMapSlice';
import { useSiteMapQuery } from 'lib/hooks/queries';
import { useAppDispatch, useAppSelector } from 'lib/hooks/redux';
import { getExternalAppURL } from 'lib/utils';

const FloorPlanModal = () => {
  // Redux Hooks and States
  const dispatch = useAppDispatch();
  const { currPlanCode } = useAppSelector((state) => ({
    currPlanCode: state.siteMap.currPlanCode!,
  }));

  // Get Site Map Data from React-Query Cache (No Params)
  const siteMapData = useSiteMapQuery().data!;

  // Semantic Vars From Site Map Data
  const {
    applicationURL: { BASE_LAUNCH_URL },
    community: { applicationID: communityId },
  } = siteMapData;

  // Functions
  const handleClose = () => {
    dispatch(setCurrPlanCode(''));
  };

  return (
    <Modal
      title="Floor Plan"
      width={'95%'}
      centered
      visible={true}
      footer={null}
      onCancel={handleClose}
      bodyStyle={{ padding: 0 }}
    >
      <iframe
        data-cy="floor-plan-iframe"
        title="floor-plan"
        src={getExternalAppURL({
          BASE_LAUNCH_URL,
          appCode: 'fp',
          communityId,
          planCode: currPlanCode,
        })}
        width="100%"
        height={window.innerHeight * 0.8}
        frameBorder="0"
      />
    </Modal>
  );
};

export default FloorPlanModal;
